import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
    categoryName: Yup.string().required('Nome é obrigatório'),
    ordering: Yup.string().required('Ordenação é obrigatório'),
});